import packingRequest from "../request/packing"

const apiRequest = packingRequest()

export const getReGenLabels = (payload) => {
    return apiRequest({
        url: '/packing/regen-label/search',
        method: 'POST',
        data: payload
    })
}

export const putFileReGenLabel = (data) => {
    return apiRequest({
        url: '/packing/regen-label-csv',
        method: 'POST',
        data: data
    })
}

export const updateContent = (id, payload) => {
    return apiRequest({
        url: `/order/re-genlabel/${id}/content`,
        method: 'PUT',
        data: payload
    })
}

export const regenLabelByOrder = (data) => {
    return apiRequest({
        url: '/packing/regen-label',
        method: 'POST',
        data: data
    })
}

export const getInfoSettingBarcode = (barcodeNumber) => {
    return apiRequest({
        url: `/order/barcode/${barcodeNumber}/weight-info`,
        method: 'GET'
    })
}

export const processRequest = (id, process, data) => {
    return apiRequest({
        url: `/packing/regen-label/${id}/${process}`,
        method: 'PUT',
        data: data
    })
}

export const bulkApproved = (data) => {
    return apiRequest({
        url: '/packing/regen-label/bulk/approved',
        method: 'PUT',
        data: data
    })
}

export const bulkRejected = (data) => {
    return apiRequest({
        url: '/packing/regen-label/bulk/rejected',
        method: 'PUT',
        data: data
    })
}

export const deleteRequest = (id) => {
    return apiRequest({
        url: `/order/re-genlabel/${id}`,
        method: 'DELETE'
    })
}

export const retryLabel = (id) => {
    return apiRequest({
        url: `/order/re-genlabel/${id}/retry`,
        method: 'POST'
    })
}

export const actionChangeShippingCarrier = (payload) => {
    return apiRequest({
        url: `/packing/shipping/carrier`,
        method: 'POST',
        data: payload
    })
}

export const getListPriorityStore = (payload) => {
    const {page, limit, ...data} = payload
    return apiRequest({
        url: `order/priority-store/search?page=${page}&limit=${limit}`,
        method: 'POST',
        data
    })  
}

export const createPriorityStore = payload => {
    return apiRequest({
        url: `order/priority-store/create`,
        method: 'POST',
        data: payload
    })
}

export const editPriorityStore = payload => {
    const {id, ...data} = payload
    return apiRequest({
        url: `order/priority-store/${id}`,
        method: 'PUT',
        data
    })
}

export const deletePriorityStore = id => {
    return apiRequest({
        url: `order/priority-store/${id}`,
        method: 'DELETE',
    })
}

export const getDetailPriorityStore = id => {
    return apiRequest({
        url: `order/priority-store/${id}`,
        method: 'GET'
    })
}

